type ElTabGroupElement = HTMLElement & { setActiveTab: (index: number) => void };

function countVisibleCards(root: HTMLElement): number {
  const panel = root.querySelector("el-tab-panels > :not([hidden])");
  if (!panel) return 0;
  return panel.querySelectorAll(".content-filter-card").length;
}

function syncStatus(root: HTMLElement, category: string) {
  const status = root.querySelector<HTMLElement>("[data-filter-status]");
  if (!status) return;
  const n = countVisibleCards(root);
  const allLabel = root.dataset.statusAll || "Showing all items.";
  const singular = root.dataset.statusSingular || "item";
  const plural = root.dataset.statusPlural || "items";
  if (category === "all") {
    status.hidden = false;
    status.textContent = allLabel;
    return;
  }
  status.hidden = false;
  const noun = n === 1 ? singular : plural;
  status.textContent = `Showing ${n} ${noun} in “${category}”.`;
}

function initContentFilterZone(root: HTMLElement) {
  const group = root.querySelector("el-tab-group") as ElTabGroupElement | null;
  if (!group || typeof group.setActiveTab !== "function") return;

  const buttons = () =>
    Array.from(root.querySelectorAll<HTMLButtonElement>("el-tab-list button[data-category]"));

  function applyUrlToTabs() {
    const vals = buttons().map((b) => b.getAttribute("data-category") || "all");
    const params = new URLSearchParams(window.location.search);
    const requested = params.get("category") || "all";
    let idx = vals.indexOf(requested);
    if (idx < 0) idx = 0;
    group.setActiveTab(idx);
    syncStatus(root, vals[idx] ?? "all");
  }

  root.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest("el-tab-list button[data-category]");
    if (!btn || !root.contains(btn)) return;
    const v = btn.getAttribute("data-category") || "all";
    const url = new URL(window.location.href);
    if (v === "all") url.searchParams.delete("category");
    else url.searchParams.set("category", v);
    window.history.replaceState({}, "", url.toString());
    queueMicrotask(() => syncStatus(root, v));
  });

  void customElements.whenDefined("el-tab-group").then(() => {
    requestAnimationFrame(() => {
      applyUrlToTabs();
    });
  });
}

document.querySelectorAll<HTMLElement>("[data-content-filter-zone]").forEach(initContentFilterZone);
